import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=43054b86"
import script from "./chart2.vue?vue&type=script&lang=js"
export * from "./chart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports